import { QUALITY_PROCEDURE_BUILDER_URL } from "../../../../utils/constService";
import api from "../../../../../BasicComponent/Service/api";

export const fetchBuilders = (params = {}) =>
  api.get(`${QUALITY_PROCEDURE_BUILDER_URL}/paged`, { params });
export const fetchBuildersByProductId = (productId) =>
  api.get(`${QUALITY_PROCEDURE_BUILDER_URL}/get-by-product-uuid/${productId}`);
export const fetchBuilderById = (uuid) =>
  api.get(`${QUALITY_PROCEDURE_BUILDER_URL}/${uuid}`);
export const postBuilder = (data) =>
  api.post(QUALITY_PROCEDURE_BUILDER_URL, data);
export const putBuilder = (data, uuid) =>
  api.put(`${QUALITY_PROCEDURE_BUILDER_URL}/${uuid}`, data);
export const deleteBuilder = (uuid) =>
  api.delete(`${QUALITY_PROCEDURE_BUILDER_URL}/${uuid}`);
